import { Stack, Typography, CircularProgress, Breadcrumbs, Link, Box, TextField, InputAdornment, Button, Grid, Divider, RadioGroup, FormControlLabel, Radio, Slider, Dialog, DialogContent, DialogActions } from "@mui/material";
import { connect } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { ArrowForwardIos } from "@mui/icons-material";
import { actionCreators } from "../../store";
import FetchHelper from "../FetchHelper";
import { TABLE_BLUE_COLOR, WIDTH_AGGRID, WIDTH_DASHBOARD_LEFT } from "../../models/Constants";
import { useForm } from 'react-hook-form';
import SearchIcon from '@mui/icons-material/Search';
import TestGrid from "./TestGrid";
import { PageData } from "../../models/Index";
import { Breakpoint, styled } from '@mui/system';
import starIcon from '../../images/icon/starIcon.svg'
import starIconWithStroke from '../../images/icon/starIconWithStroke.svg'
import useResponsive from "../../hooks/useResponsive";

const GET_RESULT_LIST = "GET_RESULT_LIST"
const GET_USER_ANSWER = "GET_USER_ANSWER"
const GET_SCORE = "GET_SCORE"
const DELETE_SCORE = "DELETE_SCORE"
const GET_TRACK_LINE = "GET_TRACK_LINE"

// 検索フォーム
interface SearchItemForm {
    "target": string;
    "limit": number;
    "page": number;
}

// 初期値設定
const initialValue: SearchItemForm = {
    target: '',
    limit: 50,
    page: 1
}

const initialPageData: PageData = {
    rowFrom: '0',
    rowTo: '0',
    totalRow: '0',
    currPage: '0',
    totalPage: '0',
};

const CustomSlider = styled(Slider)({
    '& .MuiSlider-thumb': {
      height: 30,
      width: 30,
      backgroundColor: 'transparent',
      backgroundImage:`url(${starIcon})`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:before': {
        display: 'none',
      },
    },
    '&.Mui-disabled': {
    color: '#000000',
    },
    '& .MuiSlider-rail': {
        color: '#000000',
    },
});

const styledBorder = "1px solid black"

const VerticalText = styled(Stack)({
    writingMode: 'vertical-rl',
    textOrientation: 'upright',
    textAlign: 'center',
    height: 'auto',
});

export type TestListProps = {
    defaultPage?: any;
};

export type TestList = TestListProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

export const TestList = (props: TestList) => {
    //#region Fields
    const {
        defaultPage,
        onGetList,
        onGetUserAnswer,
        onGetScore,
        onDeleteScore,
        onDeleteUserError,
        onDeleteUserSuccess,
        onGetTrackLine
    } = props;

    const isDesktop = useResponsive({ query: 'up', key: 'lg' as Breakpoint });
    const isTablet = useResponsive({ query: 'up', key: 'md' as Breakpoint });
    const isMobile= useResponsive({ query: 'up', key: 'sm' as Breakpoint });

    const [pageIndex,setPageIndex] = useState(0);
    const [loadingFlag, setLoadingFlag] = useState(false);

    const [dataSelected,setDataSelected] = useState<any>(null)
    const [testIdStore,setTestIdStore] = useState<any>(null)
    const [answerList,setAnswerList] = useState<any>(null)
    const [scoreData,setScoreData] = useState<any>(null)
    const [pageData, setPageData] = useState(initialPageData);
    const [keyword,setKeyword] = useState<any>('');
    const [openDeleteScoreDialog,setOpenDeleteScoreDialog] = useState<any>({isOpen:false,data:null});

    const containerRef = useRef<any>(null)

    const [connectLines, setConnectLines] = useState<any>([]);
    const [trackLines, setTrackLines] = useState<any>([]);
    const [lineData, setLineData] = useState<any>(null);

    const thumbRefs = [useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null)];

    let grifTestList = useRef<any>()

    const { control, handleSubmit, setValue, getValues } = useForm<SearchItemForm>({
        criteriaMode: "all",
        defaultValues: initialValue,
    });

    const handGetList = (value: SearchItemForm) =>{
        setLoadingFlag(true)
        setDataSelected(null)
        setAnswerList(null)
        setScoreData(null)
        const params = new Map<string, any>();
        if (value.limit) params.set("limit", value.limit);
        params.set("page", value.page);

        onGetList({limit: value.limit,
                    page: value.page})
    }

    useEffect(() =>{
        if(pageIndex == 0) handGetList(getValues())
    },[pageIndex])

    useEffect(() =>{
        setPageIndex(0)
    },[defaultPage])

    const handleChecked = () => {
    }

    useEffect(() => {
        if(pageIndex == 1){
            const getPosition = (value:number, width:number) => {
                switch (value) {
                    case 1:
                        return 0;
                    case 2:
                        return width / 4;
                    case 3:
                        return width / 2;
                    case 4:
                        return width * 3 / 4;
                    case 5:
                        return width;
                    default:
                        return 0;
                }
            }

            const updateLines = () => {
                const newLines = [];
                const newTrackLines = [];

                const container = containerRef.current;

                const rect1 = thumbRefs[0].current?.querySelector('.MuiSlider-thumb')?.getBoundingClientRect();
                const rect2 = thumbRefs[1].current?.querySelector('.MuiSlider-thumb')?.getBoundingClientRect();
                const rect3 = thumbRefs[2].current?.querySelector('.MuiSlider-thumb')?.getBoundingClientRect();
                const rect4 = thumbRefs[3].current?.querySelector('.MuiSlider-thumb')?.getBoundingClientRect();
                const rect5 = thumbRefs[4].current?.querySelector('.MuiSlider-thumb')?.getBoundingClientRect();
                const rect6 = thumbRefs[5].current?.querySelector('.MuiSlider-thumb')?.getBoundingClientRect();
                const rect7 = thumbRefs[6].current?.querySelector('.MuiSlider-thumb')?.getBoundingClientRect();
                const rect8 = thumbRefs[7].current?.querySelector('.MuiSlider-thumb')?.getBoundingClientRect();
                const rect9 = thumbRefs[8].current?.querySelector('.MuiSlider-thumb')?.getBoundingClientRect();

                const rect1Custom = thumbRefs[0].current?.getBoundingClientRect();
                const rect2Custom = thumbRefs[1].current?.getBoundingClientRect();
                const rect3Custom = thumbRefs[2].current?.getBoundingClientRect();
                const rect4Custom = thumbRefs[3].current?.getBoundingClientRect();
                const rect5Custom = thumbRefs[4].current?.getBoundingClientRect();
                const rect6Custom = thumbRefs[5].current?.getBoundingClientRect();
                const rect7Custom = thumbRefs[6].current?.getBoundingClientRect();
                const rect8Custom = thumbRefs[7].current?.getBoundingClientRect();
                const rect9Custom = thumbRefs[8].current?.getBoundingClientRect();

                if (rect1 && rect2 && rect3 && rect4 && rect5 && rect6 && rect7 && rect8 && rect9 && container && lineData) {
                    const containerRect = container.getBoundingClientRect();
                    const scrollLeft = container.scrollLeft;
                    const scrollTop = container.scrollTop;

                    const x1 = rect1.left - containerRect.left + scrollLeft + rect1.width / 2;
                    const y1 = rect1.top - containerRect.top + scrollTop + rect1.height / 2;

                    const x2 = rect2.left - containerRect.left + scrollLeft + rect2.width / 2;
                    const y2 = rect2.top - containerRect.top + scrollTop + rect2.height / 2;
                    
                    const x3 = rect3.left - containerRect.left + scrollLeft + rect3.width / 2;
                    const y3 = rect3.top - containerRect.top + scrollTop + rect3.height / 2;

                    const x4 = rect4.left - containerRect.left + scrollLeft + rect4.width / 2;
                    const y4 = rect4.top - containerRect.top + scrollTop + rect4.height / 2;

                    const x5 = rect5.left - containerRect.left + scrollLeft + rect5.width / 2;
                    const y5 = rect5.top - containerRect.top + scrollTop + rect5.height / 2;

                    const x6 = rect6.left - containerRect.left + scrollLeft + rect6.width / 2;
                    const y6 = rect6.top - containerRect.top + scrollTop + rect6.height / 2;

                    const x7 = rect7.left - containerRect.left + scrollLeft + rect7.width / 2;
                    const y7 = rect7.top - containerRect.top + scrollTop + rect7.height / 2;

                    const x8 = rect8.left - containerRect.left + scrollLeft + rect8.width / 2;
                    const y8 = rect8.top - containerRect.top + scrollTop + rect8.height / 2;

                    const x9 = rect9.left - containerRect.left + scrollLeft + rect9.width / 2;
                    const y9 = rect9.top - containerRect.top + scrollTop + rect9.height / 2;
                    
                    newLines.push(
                        { p1:x1, p2:y1, p3:x2, p4:y2 },
                        { p1:x2, p2:y2, p3:x3, p4:y3 },
                        { p1:x3, p2:y3, p3:x4, p4:y4 },
                        { p1:x5, p2:y5, p3:x6, p4:y6 },
                        { p1:x6, p2:y6, p3:x7, p4:y7 },
                        { p1:x7, p2:y7, p3:x8, p4:y8 },
                        { p1:x8, p2:y8, p3:x9, p4:y9 }
                    );
                    setConnectLines(newLines);

                    const x1Custom = rect1Custom.left - containerRect.left + scrollLeft + getPosition(lineData?.type1Value, rect1Custom.width);
                    const y1Custom = rect1Custom.top - containerRect.top + scrollTop + rect1Custom.height / 2;

                    const x2Custom = rect2Custom.left - containerRect.left + scrollLeft + getPosition(lineData?.type2Value, rect2Custom.width);
                    const y2Custom = rect2Custom.top - containerRect.top + scrollTop + rect2Custom.height / 2;

                    const x3Custom = rect3Custom.left - containerRect.left + scrollLeft + getPosition(lineData?.type3Value, rect3Custom.width);
                    const y3Custom = rect3Custom.top - containerRect.top + scrollTop + rect3Custom.height / 2;

                    const x4Custom = rect4Custom.left - containerRect.left + scrollLeft + getPosition(lineData?.type4Value, rect4Custom.width);
                    const y4Custom = rect4Custom.top - containerRect.top + scrollTop + rect4Custom.height / 2;

                    const x5Custom = rect5Custom.left - containerRect.left + scrollLeft + getPosition(lineData?.type5Value, rect5Custom.width);
                    const y5Custom = rect5Custom.top - containerRect.top + scrollTop + rect5Custom.height / 2;

                    const x6Custom = rect6Custom.left - containerRect.left + scrollLeft + getPosition(lineData?.type6Value, rect6Custom.width);
                    const y6Custom = rect6Custom.top - containerRect.top + scrollTop + rect6Custom.height / 2;

                    const x7Custom = rect7Custom.left - containerRect.left + scrollLeft + getPosition(lineData?.type7Value, rect7Custom.width);
                    const y7Custom = rect7Custom.top - containerRect.top + scrollTop + rect7Custom.height / 2;

                    const x8Custom = rect8Custom.left - containerRect.left + scrollLeft + getPosition(lineData?.type8Value, rect8Custom.width);
                    const y8Custom = rect8Custom.top - containerRect.top + scrollTop + rect8Custom.height / 2;

                    const x9Custom = rect9Custom.left - containerRect.left + scrollLeft + getPosition(lineData?.type9Value, rect9Custom.width);
                    const y9Custom = rect9Custom.top - containerRect.top + scrollTop + rect9Custom.height / 2;

                    newTrackLines.push(
                        { p1:x1Custom, p2:y1Custom, p3:x2Custom, p4:y2Custom },
                        { p1:x2Custom, p2:y2Custom, p3:x3Custom, p4:y3Custom },
                        { p1:x3Custom, p2:y3Custom, p3:x4Custom, p4:y4Custom },
                        { p1:x5Custom, p2:y5Custom, p3:x6Custom, p4:y6Custom },
                        { p1:x6Custom, p2:y6Custom, p3:x7Custom, p4:y7Custom },
                        { p1:x7Custom, p2:y7Custom, p3:x8Custom, p4:y8Custom },
                        { p1:x8Custom, p2:y8Custom, p3:x9Custom, p4:y9Custom }
                    );
                    setTrackLines(newTrackLines);
                }
            };

        const handle = requestAnimationFrame(updateLines);

        if (containerRef.current) {
        containerRef.current.addEventListener('scroll', updateLines);
        window.addEventListener('resize', updateLines);
        }

        return () => {
            cancelAnimationFrame(handle);
            if (containerRef.current) {
                containerRef.current.removeEventListener('scroll', updateLines);
                window.removeEventListener('resize', updateLines);
            }
        };
    }
  }, [pageData, scoreData]);

    const handleClickEditButton = (data:any) => {
        setDataSelected(data)
        handleShowScore(data.testId)
    }

    const handleShowScore = (testId:any) => {
        setPageIndex(1)
        setAnswerList(null)
        setScoreData(null)
        if(testId)
        {
            setLoadingFlag(true)
            setTestIdStore(testId)
            onGetTrackLine({})
        }
    }
    
    const handleGetTrackLineSuccess = (data:any) => {
        setLoadingFlag(false)
        if(data.resultCode == 0)
        {
            setLineData(data.data)
            if(testIdStore)
            {
                setLoadingFlag(true)
                onGetScore({
                    testId: testIdStore
                })
            }
        }
    }
    
    const handleGetTrackLineError = (data:any) => {
        setLoadingFlag(false)
    }

    const handleChangePageData = (name: any, value: any) => {
        // 値変更
        setValue(name, value);
        if (name === 'limit') {
            setValue("page", 1);
        }
        setLoadingFlag(true)
        handGetList(getValues());
    };

    const handleGetListSuccess = (success:any,data:any,error:any)=>{
        if (grifTestList && grifTestList.current) {
            grifTestList.current?.setRowData(data.data.data);
            
            const totalCount = data.data.totalCount;
            const pageSize = getValues('limit');
            const page = Number(data.data.page);
            const totalPage = Math.ceil(totalCount / pageSize);
            const rowFrom = (pageSize * page - pageSize) + 1;
            const rowTo = (pageSize * page) > totalCount ? totalCount : (pageSize * page);
            const updateData: PageData = {
                rowFrom: rowFrom.toLocaleString(),
                rowTo: rowTo.toLocaleString(),
                totalRow: totalCount.toLocaleString(),
                currPage: page.toLocaleString(),
                totalPage: totalPage.toLocaleString(),
            };
            setPageData(updateData);
        }
        else{
            grifTestList.current.setRowData([])
        }
        setLoadingFlag(false)
    }
    
    const handleGetListError = (success:any,data:any,error:any)=>{
        setLoadingFlag(false)
    }

    const handleShowDetailTest = () => {
        setPageIndex(2)
        if(dataSelected.testId && dataSelected.questionId)
        {
            setLoadingFlag(true)
            onGetUserAnswer({
                testId: dataSelected.testId,
                questionId: dataSelected.questionId
            })
        }
    }

    const handleGetUserAnswerSuccess = (data:any) => {
        setLoadingFlag(false)
        if(data.resultCode == 0)
        {
            setAnswerList(data.data)
        }
    }

    const handleGetUserAnswerError = (data:any) => {
        setLoadingFlag(false)
    }

    const handleGetScoreSuccess = (data:any) => {
        setLoadingFlag(false)
        if(data.resultCode == 0)
        {
            if(data.data)
            {
                setScoreData(data.data)
            }
            else
            {
                setScoreData({
                    "testId": dataSelected?.testId,
                    "testDate": dataSelected?.testDate,
                    "userId": dataSelected?.userId,
                    "userName": dataSelected?.userName,
                    "questionId": dataSelected?.questionId,
                    "scoreId": "",
                    "undefineTypeNumber": 100,
                    "undefineTypeScore": "C",
                    "type10Number": 0,
                    "type10Score": "C",
                    "stressToleranceTypeNumber": 4,
                    "stressToleranceTypeScore": "E",
                    "type1Number": 0,
                    "type1Score": "1",
                    "type2Number": 0,
                    "type2Score": "1",
                    "type3Number": 0,
                    "type3Score": "1",
                    "type4Number": 0,
                    "type4Score": "1",
                    "type5Number": 0,
                    "type5Score": "1",
                    "type6Number": 0,
                    "type6Score": "1",
                    "type7Number": 0,
                    "type7Score": "1",
                    "type8Number": 0,
                    "type8Score": "1",
                    "type9Number": 0,
                    "type9Score": "1",
                    "copingAbilityTypeNumber": 5,
                    "copingAbilityTypeScore": "E",
                    "riskTaskingTypeNumber": 2,
                    "riskTaskingTypeScore": "低",
                    "flexibilityTypeNumber": 3,
                    "flexibilityTypeScore": "低",
                    "typeResult": 5
                })
            }
        }
    }

    const handleGetScoreError = (data:any) => {
        setLoadingFlag(false)
    }

    const handleDeleteScore = (data:any) => {
        setOpenDeleteScoreDialog({isOpen:true,data:data})
    }

    const handleOKDeleteScore = (data:any) => {
        if(openDeleteScoreDialog.data)
        {
            setLoadingFlag(true)
            onDeleteScore({
                testId: openDeleteScoreDialog.data?.testId,
                userId: openDeleteScoreDialog.data?.userId
            })
            setOpenDeleteScoreDialog({isOpen:false,data:null})
        }
    }

    const handleDeleteScoreSuccess = (data:any) => {
        handGetList(getValues())
        onDeleteUserSuccess()
    }

    const handleDeleteScoreError = (data:any) => {
        setLoadingFlag(false)
        onDeleteUserError()
    }

    const marks = {
        undefine: [
            { value: 1, labelAbove: '35以上', labelBelow: 'C' },
            { value: 2, labelAbove: '11～34', labelBelow: 'B' },
            { value: 3, labelAbove: '0～10', labelBelow: 'A' },
        ],
        type10: [
            { value: 1, labelAbove: '0～5', labelBelow: 'C' },
            { value: 2, labelAbove: '6～8', labelBelow: 'B' },
            { value: 3, labelAbove: '9以上', labelBelow: 'A' },
        ],
        stressTolerance: [
            { value: 1, labelAbove: '4～7', labelBelow: 'E' },
            { value: 2, labelAbove: '８～10', labelBelow: 'D' },
            { value: 3, labelAbove: '11～13', labelBelow: 'C' },
            { value: 4, labelAbove: '14～16', labelBelow: 'B' },
            { value: 5, labelAbove: '17～20', labelBelow: 'A' },
        ],
        type1: [
            { value: 1, labelAbove: '0', labelBelow: '1' },
            { value: 2, labelAbove: '1・2', labelBelow: '2' },
            { value: 3, labelAbove: '3・4・5・6', labelBelow: '3' },
            { value: 4, labelAbove: '7・8', labelBelow: '4' },
            { value: 5, labelAbove: '9・10', labelBelow: '5' },
        ],
        type2: [
            { value: 1, labelAbove: '0・1', labelBelow: '1' },
            { value: 2, labelAbove: '2・3', labelBelow: '2' },
            { value: 3, labelAbove: '4・5・6', labelBelow: '3' },
            { value: 4, labelAbove: '7・8', labelBelow: '4' },
            { value: 5, labelAbove: '9・10', labelBelow: '5' },
        ],
        type3: [
            { value: 1, labelAbove: '0・1・2', labelBelow: '1' },
            { value: 2, labelAbove: '3・4', labelBelow: '2' },
            { value: 3, labelAbove: '5・6', labelBelow: '3' },
            { value: 4, labelAbove: '7・8', labelBelow: '4' },
            { value: 5, labelAbove: '9・10', labelBelow: '5' },
        ],
        type4: [
            { value: 1, labelAbove: '0・1・2', labelBelow: '1' },
            { value: 2, labelAbove: '3・4', labelBelow: '2' },
            { value: 3, labelAbove: '5・6・7', labelBelow: '3' },
            { value: 4, labelAbove: '8・9', labelBelow: '4' },
            { value: 5, labelAbove: '10', labelBelow: '5' },
        ],
        type5: [
            { value: 1, labelAbove: '0・1', labelBelow: '1' },
            { value: 2, labelAbove: '2・3', labelBelow: '2' },
            { value: 3, labelAbove: '4・5・6', labelBelow: '3' },
            { value: 4, labelAbove: '7・8', labelBelow: '4' },
            { value: 5, labelAbove: '9・10', labelBelow: '5' },
        ],
        type6: [
            { value: 1, labelAbove: '0・1・2', labelBelow: '1' },
            { value: 2, labelAbove: '3・4', labelBelow: '2' },
            { value: 3, labelAbove: '5・6・7', labelBelow: '3' },
            { value: 4, labelAbove: '8', labelBelow: '4' },
            { value: 5, labelAbove: '9・10', labelBelow: '5' },
        ],
        type7: [
            { value: 1, labelAbove: '0・1', labelBelow: '1' },
            { value: 2, labelAbove: '2・3', labelBelow: '2' },
            { value: 3, labelAbove: '4・5・6', labelBelow: '3' },
            { value: 4, labelAbove: '7・8', labelBelow: '4' },
            { value: 5, labelAbove: '9・10', labelBelow: '5' },
        ],
        type8: [
            { value: 1, labelAbove: '0・1・2', labelBelow: '1' },
            { value: 2, labelAbove: '3・4', labelBelow: '2' },
            { value: 3, labelAbove: '5・6・7', labelBelow: '3' },
            { value: 4, labelAbove: '8・9', labelBelow: '4' },
            { value: 5, labelAbove: '10', labelBelow: '5' },
        ],
        type9: [
            { value: 1, labelAbove: '0', labelBelow: '1' },
            { value: 2, labelAbove: '1・2', labelBelow: '2' },
            { value: 3, labelAbove: '3・4・5', labelBelow: '3' },
            { value: 4, labelAbove: '6・7', labelBelow: '4' },
            { value: 5, labelAbove: '8・9・10', labelBelow: '5' },
        ],
        copingAbility: [
            { value: 1, labelAbove: '5～10', labelBelow: 'E' },
            { value: 2, labelAbove: '11～13', labelBelow: 'D' },
            { value: 3, labelAbove: '14～16', labelBelow: 'C' },
            { value: 4, labelAbove: '17～19', labelBelow: 'B' },
            { value: 5, labelAbove: '20～25', labelBelow: 'A' },
        ],
        riskTasking: [
            { value: 1, labelAbove: '2～4', labelBelow: '低' },
            { value: 2, labelAbove: '5～7', labelBelow: '中' },
            { value: 3, labelAbove: '8～10', labelBelow: '高' },
        ],
        flexibility: [
            { value: 1, labelAbove: '3～7', labelBelow: '低' },
            { value: 2, labelAbove: '8～10', labelBelow: '中' },
            { value: 3, labelAbove: '11～15', labelBelow: '高' },
        ]
    }

    const handleMapDefaultValue = (data:any) => {
        switch(data) {
            case "A":
                return 5;
            case "B":
                return 4;
            case "C":
                return 3;
            case "D":
                return 2;
            case "E":
                return 1;
            case "5":
                return 5;
            case "4":
                return 4;
            case "3":
                return 3;
            case "2":
                return 2;
            case "1":
                return 1;
            default:
                return 1;
        }
    }

	return (          
        <>
            {loadingFlag && (
                        <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1500, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                            <CircularProgress />
                        </div>
                )}
            <Stack position='absolute' style={{ marginLeft:WIDTH_DASHBOARD_LEFT,marginTop:"20px"}} width={WIDTH_AGGRID}>
                <Breadcrumbs sx={{height:"50px",alignItems:"center",display:"flex",flexDirection:"row", marginLeft:"20px", fontSize:22}}  separator={<ArrowForwardIos fontSize='small' sx={{color:"black"}}/>} aria-label="breadcrumb">
                    <Link underline="hover" key="1" color="black" href={undefined} onClick={()=> setPageIndex(0)} ml={2} >
                    テスト実施管理
                    </Link>
                    <Typography key="2" sx={{ color: 'text.primary' }} noWrap fontSize={22}>
                    {pageIndex == 0 ? '実施結果一覧': pageIndex == 1 ? '診断表' : '回答内容'}
                    </Typography>
                </Breadcrumbs>
                {pageIndex == 0 &&
                    <>
                    <Stack direction='row' spacing={2} justifyContent={"flex-end"} mr={10} mt={1} alignItems={"center"}>
                        <Box marginRight={2} width={"18vw"}>
                            <TextField
                                fullWidth
                                autoComplete="searchStr"
                                name="keyword"
                                type="text"
                                label="フィルター"
                                size="small"
                                value={keyword}
                                onChange={e =>  {setKeyword(e.target.value)}}
                                InputProps={{
                                    sx: { borderRadius: "8px" },
                                    startAdornment:null,
                                    endAdornment:(
                                    <InputAdornment position="end">
                                        <SearchIcon/>
                                    </InputAdornment>)
                                }}
                            />
                        </Box>
                        <Box marginRight={2}>
                            <Button variant="outlined" onClick={e => {setKeyword("")}}>クリア</Button>
                        </Box>
                    </Stack>
                    <Stack marginLeft={5} mr={10} mt={1}>
                        <TestGrid 
                            ref={grifTestList} 
                            keyword={keyword} 
                            onSelected={handleChecked} 
                            onDoubleClick={handleClickEditButton} 
                            isSearch={dataSelected == null?true:false}
                            pageData={pageData}
                            pageSize={getValues('limit')}
                            onChangeSearchCondition={handleChangePageData}
                            onDeleteScore={handleDeleteScore}
                        />
                    </Stack>
                    </>
                }
                {
                    pageIndex == 1 && dataSelected &&
                    <>
                    <Grid container direction={"row"} justifyContent={"center"} alignItems={"center"} spacing={3}>
                        <Grid item xs={3}>
                            <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} spacing={1}>
                                <Typography>受検者：</Typography>
                                <Box sx={{border:"1px solid grey", borderRadius:"8px", height:"30px", alignContent:"center", justifyItems:"center", width:"60%"}}>
                                    <Typography color={"grey"}>{dataSelected.userName}</Typography>
                                </Box>
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} spacing={1}>
                                <Typography>実施日：</Typography>
                                <Box sx={{border:"1px solid grey", borderRadius:"8px", height:"30px", alignContent:"center", justifyItems:"center", width:"60%"}}>
                                    <Typography color={"grey"}>{dataSelected.testDate}</Typography>
                                </Box>
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} spacing={1}>
                                <Button variant="contained" onClick={()=>handleShowDetailTest()}>回答内容</Button>
                            </Stack>
                        </Grid>
                    </Grid>
                    {scoreData &&
                        <>
                        <Stack ref={containerRef} position={'relative'} direction={"column"} maxHeight={"75vh"} width={isDesktop?'94%':'98%'} overflow={"auto"} marginTop={4} alignSelf={"center"}>
                            <svg
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '1200px',
                                    pointerEvents: 'none',
                                    zIndex: 2,
                                }}
                            >
                                {connectLines.map((line:any, index:any) => (
                                <line
                                    key={index}
                                    x1={line.p1}
                                    y1={line.p2}
                                    x2={line.p3}
                                    y2={line.p4}
                                    stroke="rgb(91, 155, 231)"
                                    strokeWidth="2.5"
                                />
                                ))}

                                {trackLines.map((line:any, index:any) => (
                                <line
                                    key={index}
                                    x1={line.p1}
                                    y1={line.p2}
                                    x2={line.p3}
                                    y2={line.p4}
                                    stroke="rgb(255, 0, 0)"
                                    strokeWidth="2.5"
                                    strokeDasharray="5"
                                />
                                ))}
                            </svg>

                            <Grid container direction={"row"} minHeight={"180px"} height={"auto"} width={"99.9%"}>
                                <Grid item xs={0.75} justifyItems={"center"} alignContent={"center"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <VerticalText>検査結果の信頼性</VerticalText>
                                </Grid>
                                <Grid item xs={0.5} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <Stack height={"24.5%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.undefineTypeNumber}
                                    </Stack>
                                    <Stack height={"24.5%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.undefineTypeScore}
                                    </Stack>
                                    <Stack height={"24.5%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type10Number}
                                    </Stack>
                                    <Stack height={"25%"} justifyContent={"center"} alignItems={"end"} fontWeight={"bold"} pr={1} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type10Score}
                                    </Stack>
                                </Grid>
                                <Grid item xs={5.3} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <Stack height={"49.5%"} direction={"row"} borderBottom={styledBorder} justifyContent={"center"}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} pl={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:-1}}>
                                                        {marks.undefine.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            min={1}
                                                            max={3}
                                                            defaultValue={scoreData.undefineTypeScore == "A" ? 3: scoreData.undefineTypeScore == "B" ? 2 : 1}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.undefine.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack height={"50%"} direction={"row"} justifyContent={"center"}>
                                    <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} pl={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:1}}>
                                                        {marks.type10.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            min={1}
                                                            max={3}
                                                            defaultValue={scoreData.type10Score == "A" ? 3: scoreData.type10Score == "B" ? 2 : 1}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type10.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={1.6} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder} >
                                    <Stack height={"49.5%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Typography variant={isDesktop?"body1":"caption"}>疑問点</Typography>
                                    </Stack>
                                    <Stack height={"50%"} justifyContent={"center"} pl={1}>
                                        <Typography variant={isDesktop?"body1":"caption"}>信用尺度</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={3.85} direction={"column"} borderLeft={styledBorder} >
                                    
                                </Grid>
                            </Grid>

                            <Grid container direction={"row"} minHeight={"450px"} width={"99.9%"} pt={0}>
                                <Grid item xs={0.75} justifyItems={"center"} alignContent={"center"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <VerticalText>原因別ストレス耐性</VerticalText>
                                </Grid>
                                <Grid item xs={0.5} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <Stack height={"9.8%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.stressToleranceTypeNumber}
                                    </Stack>
                                    <Stack height={"9.8%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.stressToleranceTypeScore}
                                    </Stack>
                                    <Stack height={"9.8%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type1Number}
                                    </Stack>
                                    <Stack height={"9.8%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} fontWeight={"bold"} pr={1} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type1Score}
                                    </Stack>
                                    <Stack height={"9.8%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type2Number}
                                    </Stack>
                                    <Stack height={"9.8%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type2Score}
                                    </Stack>
                                    <Stack height={"9.8%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type3Number}
                                    </Stack>
                                    <Stack height={"9.8%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} fontWeight={"bold"} pr={1} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type3Score}
                                    </Stack>
                                    <Stack height={"9.8%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type4Number}
                                    </Stack>
                                    <Stack height={"10%"} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type4Score}
                                    </Stack>
                                </Grid>
                                <Grid item xs={5.3} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <Stack direction={"row"} justifyContent={"center"} height={"19.9%"} borderBottom={styledBorder}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点合計</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} pl={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>総合判定</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:0.5}}>
                                                        {marks.stressTolerance.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop ? (index == 1? 1.5:0) : (index == 1? 1:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.stressToleranceTypeScore)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.stressTolerance.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent={"center"} height={"19.9%"} borderBottom={styledBorder}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} pr={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} alignItems={"end"} pr={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5}}>
                                                        {marks.type1.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop?(index==0?2:index==1? 2.5: index==2?-2:index==3?-2:0):(index==0?2:index==1? 1: index==2?-2:index==3?-2:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            ref={thumbRefs[0]}
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.type1Score)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type1.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent={"center"} height={"19.8%"} borderBottom={styledBorder}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} pr={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} alignItems={"end"} pr={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:0.5}}>
                                                        {marks.type2.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop?(index == 1? 1:index==2?-0.5:index==3?-0.5:0):(index == 1? 0.5:index==2?-0.5:index==3?-0.5:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            ref={thumbRefs[1]}
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.type2Score)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type2.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent={"center"} height={"19.8%"} borderBottom={styledBorder}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} pr={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} alignItems={"end"} pr={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:-1}}>
                                                        {marks.type3.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop?(index==1?-1:index==2?0.5:index==3?1:0):(index==1?0:index==2?0.5:index==3?1:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            ref={thumbRefs[2]}
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.type3Score)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type3.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent={"center"} height={"20%"}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} pr={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} alignItems={"end"} pr={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:-1}}>
                                                        {marks.type4.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop?(index==1?-4:index==2?-4:index==3?-4:0):(index==1?-3:index==2?-3:index==3?-3:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            ref={thumbRefs[3]}
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.type4Score)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type4.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={1.6} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <Stack height={"19.9%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Typography variant={isDesktop?"body1":"caption"}>原因別ストレス耐性</Typography>
                                        <Typography variant={isDesktop?"body1":"caption"}>総合判定</Typography>
                                    </Stack>
                                    <Stack height={"19.9%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Stack direction={"row"} spacing={1}>
                                            <Typography variant={isDesktop?"body1":"caption"} gutterBottom style={{alignContent:'center'}}>①</Typography>
                                            <Stack direction={"column"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>対人</Typography>
                                                <Typography variant={isDesktop?"body1":"caption"}>ストレス耐性</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack height={"19.8%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Stack direction={"row"} spacing={1}>
                                            <Typography variant={isDesktop?"body1":"caption"} gutterBottom style={{alignContent:'center'}}>②</Typography>
                                            <Stack direction={"column"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>対課題</Typography>
                                                <Typography variant={isDesktop?"body1":"caption"}>ストレス耐性</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack height={"19.8%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Stack direction={"row"} spacing={1}>
                                            <Typography variant={isDesktop?"body1":"caption"} gutterBottom style={{alignContent:'center'}}>③</Typography>
                                            <Stack direction={"column"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>対役割</Typography>
                                                <Typography variant={isDesktop?"body1":"caption"}>ストレス耐性</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack height={"20%"} justifyContent={"center"} pl={1}>
                                        <Stack direction={"row"} spacing={1}>
                                            <Typography variant={isDesktop?"body1":"caption"} gutterBottom style={{alignContent:'center'}}>④</Typography>
                                            <Stack direction={"column"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>対環境</Typography>
                                                <Typography variant={isDesktop?"body1":"caption"}>ストレス耐性</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={3.85} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <Stack direction={"row"} height={"19.9%"} width={"100%"} borderBottom={styledBorder} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"}>
                                            <Typography variant={isDesktop?"body1":"caption"}>ﾁｪｯｸ欄</Typography>
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>診断内容</Typography>
                                            <Typography variant={isDesktop?"body1":"caption"}>ﾁｪｯｸ欄：換算点が4以上で○、１の場合は✕</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} height={"19.9%"} width={"100%"} borderBottom={styledBorder} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                            {scoreData.type1Score == 1 ? '✕' : scoreData.type1Score == 4 || scoreData.type1Score == 5 ? '○' : ''}
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>人間関係から生じるストレス要因に対して過剰に敏感にならないかどうか</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} height={"19.8%"} width={"100%"} borderBottom={styledBorder} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                            {scoreData.type2Score == 1 ? '✕' : scoreData.type2Score == 4 || scoreData.type2Score == 5 ? '○' : ''}
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>自分にとって難易度の高い課題に対して、積極的に対処できるかどうか</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} height={"19.8%"} width={"100%"} borderBottom={styledBorder} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                            {scoreData.type3Score == 1 ? '✕' : scoreData.type3Score == 4 || scoreData.type3Score == 5 ? '○' : ''}
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>組織のなかで重要な役割を担うことを苦にしないかどうか</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} height={"20%"} width={"100%"} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                            {scoreData.type4Score == 1 ? '✕' : scoreData.type4Score == 4 || scoreData.type4Score == 5 ? '○' : ''}
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>周囲の物理的な環境変化に対して臨機応変に適応できるかどうか</Typography>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            </Grid>

                            <Grid container direction={"row"} minHeight={"540px"} width={"99.9%"} pt={0}>
                                <Grid item xs={0.75} justifyItems={"center"} alignContent={"center"} borderTop={styledBorder} borderLeft={styledBorder} borderBottom={styledBorder}>
                                    <VerticalText>ストレス対処資質</VerticalText>
                                </Grid>
                                <Grid item xs={0.5} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder} borderBottom={styledBorder}>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type5Number}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type5Score}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type6Number}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} fontWeight={"bold"} pr={1} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type6Score}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type7Number}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type7Score}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type8Number}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} fontWeight={"bold"} pr={1} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type8Score}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type9Number}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.type9Score}
                                    </Stack>
                                    <Stack height={"8.16%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.copingAbilityTypeNumber}
                                    </Stack>
                                    <Stack height={"8.26%"} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.copingAbilityTypeScore}
                                    </Stack>
                                </Grid>
                                <Grid item xs={5.3} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder} borderBottom={styledBorder}>
                                    <Stack direction={"row"} justifyContent={"center"} height={"16.4%"} borderBottom={styledBorder}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} pr={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} alignItems={"end"} pr={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:0.5}}>
                                                        {marks.type5.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop?(index==1?1:index==2?-0.5:index==3?-0.5:0):(index==1?0.5:index==2?-0.5:index==3?-0.5:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            ref={thumbRefs[4]}
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.type5Score)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type5.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent={"center"} height={"16.6%"} borderBottom={styledBorder}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} pr={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} alignItems={"end"} pr={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:-1}}>
                                                        {marks.type6.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop?(index==1?-2:index==2?-2.2:0):(index==1?-2:index==2?-2:index==3?-1:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            ref={thumbRefs[5]}
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.type6Score)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type6.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent={"center"} height={"16.5%"} borderBottom={styledBorder}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} pr={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} alignItems={"end"} pr={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:0.5}}>
                                                        {marks.type7.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={index==1?1:index==2?-0.5:0}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            ref={thumbRefs[6]}
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.type7Score)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type7.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent={"center"} height={"16.5%"} borderBottom={styledBorder}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} pr={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} alignItems={"end"} pr={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:-1}}>
                                                        {marks.type8.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop?(index==1?-4:index==2?-4:index==3?-4:0):(index==1?-3:index==2?-3:index==3?-3:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            ref={thumbRefs[7]}
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.type8Score)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type8.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent={"center"} height={"16.5%"} borderBottom={styledBorder}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} pr={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>粗点</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} alignItems={"end"} pr={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:2}}>
                                                        {marks.type9.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop?(index==1?5.5:index==2?2:index==3?2:0):(index==1?3.5:index==2?1:index==3?1:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            ref={thumbRefs[8]}
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.type9Score)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.type9.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} justifyContent={"center"} height={"16.5%"}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点合計</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} pl={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>総合判定</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:isDesktop?0:0.5}}>
                                                        {marks.copingAbility.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={isDesktop?(index==1?0.5:index==2?0.5:0):(index==1?0.5:0)}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            min={1}
                                                            max={5}
                                                            defaultValue={handleMapDefaultValue(scoreData.copingAbilityTypeScore)}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.copingAbility.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={1.6} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder} borderBottom={styledBorder}>
                                    <Stack height={"16.4%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Stack direction={"row"} spacing={1}>
                                            <Typography variant={isDesktop?"body1":"caption"} gutterBottom style={{alignContent:'center'}}>⑤</Typography>
                                            <Typography variant={isDesktop?"body1":"caption"}>自己効力</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack height={"16.6%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Stack direction={"row"} spacing={1}>
                                            <Typography variant={isDesktop?"body1":"caption"} gutterBottom style={{alignContent:'center'}}>⑥</Typography>
                                            <Stack direction={"column"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>思考の</Typography>
                                                <Typography variant={isDesktop?"body1":"caption"}>コントロール</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack height={"16.5%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Stack direction={"row"} spacing={1}>
                                            <Typography variant={isDesktop?"body1":"caption"} gutterBottom style={{alignContent:'center'}}>⑦</Typography>
                                            <Stack direction={"column"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>感情の</Typography>
                                                <Typography variant={isDesktop?"body1":"caption"}>コントロール</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack height={"16.5%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Stack direction={"row"} spacing={1}>
                                            <Typography variant={isDesktop?"body1":"caption"} gutterBottom style={{alignContent:'center'}}>⑧</Typography>
                                            <Stack direction={"column"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>サポート</Typography>
                                                <Typography variant={isDesktop?"body1":"caption"}>活用力</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                    <Stack height={"16.5%"} borderBottom={styledBorder} justifyContent={"center"} pl={1}>
                                        <Stack direction={"row"} spacing={1}>
                                            <Typography variant={isDesktop?"body1":"caption"} gutterBottom style={{alignContent:'center'}}>⑨</Typography>
                                            <Typography variant={isDesktop?"body1":"caption"}>タフマインド</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack height={"16.5%"} justifyContent={"center"} pl={1}>
                                        <Typography variant={isDesktop?"body1":"caption"}>ストレス対処資質</Typography>
                                        <Typography variant={isDesktop?"body1":"caption"}>総合判定</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={3.85} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <Stack direction={"row"} height={"16.4%"} width={"100%"} borderBottom={styledBorder} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                            {scoreData.type5Score == 1 ? '✕' : scoreData.type5Score == 4 || scoreData.type5Score == 5 ? '○' : ''}
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>体験に基づく自信と有能感があり、ものごとに対して挑戦的な姿勢をもっているかどうか</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} height={"16.6%"} width={"100%"} borderBottom={styledBorder} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                            {scoreData.type6Score == 1 ? '✕' : scoreData.type6Score == 4 || scoreData.type6Score == 5 ? '○' : ''}
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>困難な状況でも見方を変えることで前向きでいられるかどうか</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} height={"16.5%"} width={"100%"} borderBottom={styledBorder} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                            {scoreData.type7Score == 1 ? '✕' : scoreData.type7Score == 4 || scoreData.type7Score == 5 ? '○' : ''}
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>周りの人の言葉や能度に過敏にならず、安定した精神状態でいられるかどうか</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} height={"16.5%"} width={"100%"} borderBottom={styledBorder} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                            {scoreData.type8Score == 1 ? '✕' : scoreData.type8Score == 4 || scoreData.type8Score == 5 ? '○' : ''}
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>問題が起こったときに、友人・家族や専門家などの力を活用することができるかどうか</Typography>
                                        </Stack>
                                    </Stack>
                                    <Stack direction={"row"} height={"16.3%"} width={"100%"} borderBottom={styledBorder} borderRight={styledBorder}>
                                        <Stack width={"13%"} height={"100%"} justifyContent={"center"} alignItems={"center"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                            {scoreData.type9Score == 1 ? '✕' : scoreData.type9Score == 4 || scoreData.type9Score == 5 ? '○' : ''}
                                        </Stack>
                                        <Stack width={"87%"} height={"100%"} borderLeft={styledBorder}  justifyContent={"center"} pl={1}>
                                            <Typography variant={isDesktop?"body1":"caption"}>思うようにいかない状況でも、それにめげない 性格や態度面での強靭さをもっているかどうか</Typography>
                                        </Stack>
                                    </Stack>
                                   
                                </Grid>
                            </Grid>
                            <Grid marginTop={5} marginBottom={0.5} pt={0}>
                                <Typography fontSize={isDesktop?20:15}>※ストレス対処資質のタイプ（診断結果によっては、どのタイプにも当てはまらない場合あり）</Typography>
                            </Grid>

                            <Grid container direction={"row"} minHeight={"90px"} width={"99.9%"} pt={0}>
                                <Grid item xs={0.75} justifyItems={"center"} direction={"row"} alignContent={"center"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <VerticalText maxHeight={"70px"}>リスクテイク度</VerticalText>
                                </Grid>
                                <Grid item xs={0.5} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder}>
                                    <Stack height={"49.5%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.riskTaskingTypeNumber}
                                    </Stack>
                                    <Stack height={"49.5%"} justifyContent={"center"} alignItems={"end"} fontWeight={"bold"} pr={1} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.riskTaskingTypeScore}
                                    </Stack>
                                </Grid>
                                <Grid item xs={5.3} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder}>
                                        <Stack height={"100%"} direction={"row"} justifyContent={"center"}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点合計</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} pl={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>総合判定</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:0.5}}>
                                                        {marks.riskTasking.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={index==1?0.5:0}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            min={1}
                                                            max={3}
                                                            defaultValue={scoreData.riskTaskingTypeScore == "高" ? 3: scoreData.riskTaskingTypeScore == "中" ? 2 : 1}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.riskTasking.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={5.45} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder} borderRight={styledBorder}>
                                    <Stack height={"100%"} justifyContent={"center"} pl={1}>
                                        <Typography variant={isDesktop?"body1":"caption"}>自分の力を信じて、失敗を恐れずに前に踏み出していくことで、ストレスを乗り越えていく度合い（⑤＋⑨）</Typography>
                                    </Stack>
                                </Grid>
                            </Grid>

                            <Grid container direction={"row"} minHeight={"90px"} width={"99.9%"} pt={0}>
                                <Grid item xs={0.75} justifyItems={"center"} direction={"row"} alignContent={"center"} borderTop={styledBorder} borderLeft={styledBorder} borderBottom={styledBorder}>
                                    <VerticalText>柔軟度</VerticalText>
                                </Grid>
                                <Grid item xs={0.5} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder} borderBottom={styledBorder}>
                                    <Stack height={"49.5%"} borderBottom={styledBorder} justifyContent={"center"} alignItems={"end"} pr={1} fontWeight={"bold"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.flexibilityTypeNumber}
                                    </Stack>
                                    <Stack height={"49.4%"} justifyContent={"center"} alignItems={"end"} fontWeight={"bold"} pr={1} color={"red"} sx={{backgroundColor:TABLE_BLUE_COLOR}}>
                                        {scoreData.flexibilityTypeScore}
                                    </Stack>
                                </Grid>
                                <Grid item xs={5.3} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder} borderBottom={styledBorder}>
                                        <Stack height={"100%"} direction={"row"} justifyContent={"center"}>
                                        <Stack direction={"column"} width={"19.5%"}>
                                            <Stack height={"49.5%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>換算点合計</Typography>
                                            </Stack>
                                            <Stack height={"50%"} justifyContent={"center"} pl={1} color={"red"}>
                                                <Typography variant={isDesktop?"body1":"caption"}>総合判定</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack width={"80%"} justifyContent={"center"} alignItems={"center"}>
                                            <Stack direction={"column"} width={"90%"}>
                                                <Box sx={{ width: "100%", alignItems:"center"}}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: -0.5, ml:0.5}}>
                                                        {marks.flexibility.map((mark,index) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} ml={index==1?1.5:0}>
                                                            {mark.labelAbove}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                    <Box sx={{paddingInline:"20px"}}>
                                                        <CustomSlider
                                                            min={1}
                                                            max={3}
                                                            defaultValue={scoreData.flexibilityTypeScore == "高" ? 3: scoreData.flexibilityTypeScore == "中" ? 2 : 1}
                                                            aria-labelledby="custom-slider"
                                                            step={1}
                                                            track={false}
                                                            sx={{color:"black",zIndex:4}}
                                                            disabled={true}
                                                        />
                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -0.5, marginInline:"15px"}}>
                                                        {marks.flexibility.map((mark) => (
                                                        <Typography key={mark.value} variant={isDesktop?"body1":"caption"} color="red">
                                                            {mark.labelBelow}
                                                        </Typography>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={5.45} direction={"column"} borderTop={styledBorder} borderLeft={styledBorder} borderBottom={styledBorder} borderRight={styledBorder}>
                                    <Stack height={"100%"} justifyContent={"center"} pl={1}>
                                        <Typography variant={isDesktop?"body1":"caption"}>ものの見方や気持ちを切り替え、また、必要に応じて人の力を借りることでストレス状況を乗り越えようとする度合い（⑥＋⑦＋⑧）</Typography>
                                    </Stack>
                                </Grid>
                            </Grid>

                            <Grid container direction={"row"} minHeight={"540px"}  width={"99.8%"} mt={5} pt={0}>
                                <Grid item xs={5.15}>
                                    <Stack direction={"column"} justifyContent={isDesktop?"center":"normal"} alignItems={isDesktop?"center":"normal"}>
                                        <Stack direction={"column"} position={"relative"} >
                                            <Stack alignItems={"start"}>
                                                <Typography fontSize={isDesktop?20:15}>【２軸マトリックス】</Typography>
                                            </Stack>
                                            <Stack direction={"row"} width={'400px'} height={'270px'} >
                                                <Stack height={"100%"} width={isDesktop ? "50px" : "30px"} justifyContent={"center"} alignItems={"end"} fontSize={isDesktop?20:15} mt={1}>
                                                    <VerticalText>柔 軟 度</VerticalText>
                                                </Stack>
                                                <Stack height={"100%"} width={"50px"} justifyContent={"center"} color={"#0070c0"} fontSize={isDesktop?25:20} alignItems={"center"} mt={1}>
                                                    <VerticalText>高　　中　　低</VerticalText>
                                                </Stack>
                                                <Stack position={"absolute"} top={-28} left={isDesktop? -34 : -53} display={'flex'} justifyContent={'center'} alignItems={'center'} zIndex={-1}>
                                                    <svg height={340} width={200} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <defs>
                                                        <linearGradient id="grad1" x1="0%" y1="100%" x2="0%" y2="0%">
                                                        <stop offset="0%" style={{stopColor:"#FFF2CB",stopOpacity:1}}/>
                                                        <stop offset="100%" style={{stopColor:"#ffd147",stopOpacity:1}} />
                                                        </linearGradient>
                                                    </defs>
                                                    <path
                                                        d="M13,0 L16,4 L15,4 L15,31.5 L11,31.5 L11,4 L10,4 Z"
                                                        style={{fill:`url(#grad1)`,stroke:"none"}}
                                                    />
                                                    </svg>
                                                </Stack>
                                                <Stack direction={"row"} height={"270px"} width={"270px"} mt={isDesktop?1.4:2.2}>
                                                    <Stack direction={"column"} height={"270px"} width={"90px"}>
                                                        <Stack sx={{backgroundImage:scoreData.typeResult == "4" ?`url(${starIconWithStroke})`:'',color:scoreData.typeResult == "4" ?'white':'black'}} borderLeft={styledBorder} borderTop={styledBorder} height={"33%"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
                                                            <Typography variant="h5" fontWeight={"bold"}>4</Typography>
                                                        </Stack>
                                                        <Stack sx={{backgroundImage:scoreData.riskTaskingTypeScore == "低" && scoreData.flexibilityTypeScore == "中" ?`url(${starIconWithStroke})`:''}} borderLeft={styledBorder} borderTop={styledBorder} height={"33%"} width={"100%"}>
                                                            
                                                        </Stack>
                                                        <Stack sx={{backgroundImage:scoreData.typeResult == "5" ?`url(${starIconWithStroke})`:'',color:scoreData.typeResult == "5" ?'white':'black'}} borderLeft={styledBorder} borderTop={styledBorder} borderBottom={styledBorder} height={"33%"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
                                                            <Typography variant="h5" fontWeight={"bold"}>5</Typography>
                                                        </Stack>
                                                    </Stack>
                                                    <Stack direction={"column"} height={"270px"} width={"90px"}>
                                                        <Stack sx={{backgroundImage:scoreData.riskTaskingTypeScore == "中" && scoreData.flexibilityTypeScore == "高" ?`url(${starIconWithStroke})`:''}} borderLeft={styledBorder} borderTop={styledBorder} height={"33%"} width={"100%"}>

                                                        </Stack>
                                                        <Stack sx={{backgroundImage:scoreData.typeResult == "3" ?`url(${starIconWithStroke})`:'',color:scoreData.typeResult == "3" ?'white':'black'}} borderLeft={styledBorder} borderTop={styledBorder} height={"33%"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
                                                            <Typography variant="h5" fontWeight={"bold"}>3</Typography>
                                                        </Stack>
                                                        <Stack sx={{backgroundImage:scoreData.riskTaskingTypeScore == "中" && scoreData.flexibilityTypeScore == "低" ?`url(${starIconWithStroke})`:''}} borderLeft={styledBorder} borderTop={styledBorder} borderBottom={styledBorder} height={"33%"} width={"100%"}>
                                                        
                                                        </Stack>
                                                    </Stack>
                                                    <Stack direction={"column"} height={"270px"} width={"90px"}>
                                                        <Stack sx={{backgroundImage:scoreData.typeResult == "1" ?`url(${starIconWithStroke})`:'',color:scoreData.typeResult == "1" ?'white':'black'}} borderLeft={styledBorder} borderTop={styledBorder} borderRight={styledBorder} height={"33%"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
                                                            <Typography variant="h5" fontWeight={"bold"}>1</Typography>
                                                        </Stack>
                                                        <Stack sx={{backgroundImage:scoreData.riskTaskingTypeScore == "高" && scoreData.flexibilityTypeScore == "中" ?`url(${starIconWithStroke})`:''}} borderLeft={styledBorder} borderTop={styledBorder} borderRight={styledBorder} height={"33%"}width={"100%"}>
                                                            
                                                        </Stack>
                                                        <Stack sx={{backgroundImage:scoreData.typeResult == "2" ?`url(${starIconWithStroke})`:'',color:scoreData.typeResult == "2" ?'white':'black'}} borderLeft={styledBorder} borderTop={styledBorder} borderBottom={styledBorder} borderRight={styledBorder} height={"33%"} width={"100%"} justifyContent={"center"} alignItems={"center"}>
                                                            <Typography variant="h5" fontWeight={"bold"}>2</Typography>
                                                        </Stack>
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                            <Stack direction={"column"} width={isDesktop? '470px' : '430px'} height={'200px'} mt={2}>
                                                <Stack position={"absolute"} top={244} left={isDesktop ? 34 : 20} display={'flex'} justifyContent={'center'} alignItems={'center'} zIndex={-1}>
                                                    <svg height={200} width={340} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                    <defs>
                                                        <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="0%">
                                                        <stop offset="0%" style={{stopColor:"#FFF2CB",stopOpacity:1}}/>
                                                        <stop offset="100%" style={{stopColor:"#ffd147",stopOpacity:1}}/>
                                                        </linearGradient>
                                                    </defs>
                                                    <path
                                                        d="M32,11 L28,8 L28,9 L0,9 L0,13 L28,13 L28,14 Z"
                                                        style={{fill:`url(#grad2)`,stroke:"none"}}
                                                    />
                                                    </svg>
                                                </Stack>
                                                <Stack height={"44px"} width={"100%"} justifyContent={isDesktop?"center":"end"} alignItems={"center"}>
                                                    <Typography color={"#0070c0"} fontSize={isDesktop? 25 : 20} left={""}>低　　中　　高</Typography>
                                                </Stack>
                                                <Stack height={isDesktop?"50px":"40px"} width={"100%"} justifyContent={isDesktop?"start":"center"} alignItems={"center"}>
                                                    <Typography fontSize={isDesktop? 20: 15}>リ ス ク テ イ ク 度</Typography>
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Grid>
                                <Grid item xs={6.85}>
                                    <Stack direction={"column"} height={"450px"} width={"99.8%"} mt={5}>
                                        <Stack direction={"row"} height={"19.6%"} width={"100%"} borderTop={styledBorder} borderLeft={styledBorder} borderRight={styledBorder}>
                                            <Stack width={"20%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>1：積極協働型</Typography>
                                            </Stack>
                                            <Stack width={"80%"} borderLeft={styledBorder} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>ストレスに対処していくうえで、自分の意思を貫く自信と、状況に応じた冷静な判断力を備え、周囲の援助も活用できるバランスがとれたタイプ</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack direction={"row"} height={"19.6%"} width={"100%"} borderTop={styledBorder} borderLeft={styledBorder} borderRight={styledBorder}>
                                            <Stack width={"20%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>2：積極協働型</Typography>
                                            </Stack>
                                            <Stack width={"80%"} borderLeft={styledBorder} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>ストレスに対処していくうえで、自らが信じた道を突き進む強さをもち、目標に対して、失敗を恐れずに挑んでいくタイプ</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack direction={"row"} height={"19.6%"} width={"100%"} borderTop={styledBorder} borderLeft={styledBorder} borderRight={styledBorder}>
                                            <Stack width={"20%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>3：平均型</Typography>
                                            </Stack>
                                            <Stack width={"80%"} borderLeft={styledBorder} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>「リスクテイク」「柔軟度」ともに、平均的水準にあり、特に目立った面が見られないタイプ</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack direction={"row"} height={"19.6%"} width={"100%"} borderTop={styledBorder} borderLeft={styledBorder} borderRight={styledBorder}>
                                            <Stack width={"20%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>4：協調融和型</Typography>
                                            </Stack>
                                            <Stack width={"80%"} borderLeft={styledBorder} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>ストレスに対処していくうえで、自己中心的にならず、周囲の意見を参考にして、ものの見方や気持ちを切り替えていくタイプ</Typography>
                                            </Stack>
                                        </Stack>
                                        <Stack direction={"row"} height={"19.6%"} width={"100%"} borderTop={styledBorder} borderLeft={styledBorder} borderBottom={styledBorder} borderRight={styledBorder}>
                                            <Stack width={"20%"} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>5：要開発型</Typography>
                                            </Stack>
                                            <Stack width={"80%"} borderLeft={styledBorder} justifyContent={"center"} pl={1}>
                                                <Typography variant={isDesktop?"body1":"caption"}>ストレスに対処していくうえで、自分の中の資源が不足している、または十分に活用できていないので、開発を必要とするタイプ</Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Grid>
                            </Grid>
                        </Stack>
                        </>
                    }
                    </>
                }
                {
                    pageIndex == 2 && dataSelected &&
                    <>
                    <Grid container direction={"row"} justifyContent={"center"} alignItems={"center"} spacing={3}>
                        <Grid item xs={3}>
                            <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} spacing={1}>
                                <Typography>受検者：</Typography>
                                <Box sx={{border:"1px solid grey", borderRadius:"8px", height:"30px", alignContent:"center", justifyItems:"center", width:"60%"}}>
                                    <Typography color={"grey"}>{dataSelected.userName}</Typography>
                                </Box>
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} spacing={1}>
                                <Typography>実施日：</Typography>
                                <Box sx={{border:"1px solid grey", borderRadius:"8px", height:"30px", alignContent:"center", justifyItems:"center", width:"60%"}}>
                                    <Typography color={"grey"}>{dataSelected.testDate}</Typography>
                                </Box>
                            </Stack>
                        </Grid>
                        <Grid item xs={3}>
                            <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} spacing={1}>
                                <Button variant="contained" onClick={()=>handleShowScore(dataSelected?.testId??null)}>診断表</Button>
                            </Stack>
                        </Grid>
                    </Grid>
                    {
                    <Stack  direction={"column"} maxHeight={"75vh"} width={"80%"} overflow={"auto"} marginTop={4} alignSelf={"center"}>
                        {
                            answerList && answerList.map((item:any,index:any)=>{
                                return(<>
                                <Grid container direction={"row"} alignItems={"center"} width={"100%"} mt={1} sx={{backgroundColor:item.isSelected ? "#d9d9d9":"#white"}}>
                                    <Grid item xs={1}>{'Q' + item.questionNo}</Grid>
                                    <Grid item xs={7.5}>{item.content}</Grid>
                                    <Grid item xs={3.5}>
                                        <RadioGroup
                                            row={true}
                                            defaultValue={item.answer}
                                        >
                                            <FormControlLabel value={"0"} sx={{'& .MuiFormControlLabel-label.Mui-disabled': {color: 'black'}}} control={<Radio disabled sx={{'&.Mui-disabled': {color: 'black'}}}/>} label="はい" />
                                            <FormControlLabel value={"1"} sx={{'& .MuiFormControlLabel-label.Mui-disabled': {color: 'black'}}} control={<Radio disabled sx={{'&.Mui-disabled': {color: 'black'}}}/>} label="いいえ" />
                                            <FormControlLabel value={"2"} sx={{'& .MuiFormControlLabel-label.Mui-disabled': {color: 'black'}}} control={<Radio disabled sx={{'&.Mui-disabled': {color: 'black'}}}/>} label="？" />
                                        </RadioGroup>
                                    </Grid>
                                </Grid>
                                <Divider/>
                                </>)
                            })
                        }
                    </Stack>
                    }
                    </>
                }
            </Stack>

            {openDeleteScoreDialog.isOpen &&
                <Dialog
                    open={true}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{
                        '& .MuiPaper-root': {
                        borderRadius: '8px',
                        border:"1px solid black",
                        width:"50vw"
                        },
                    }}
                    >
                    <DialogContent>
                            <Box>
                                {`　受検者「${openDeleteScoreDialog?.data?.userName}」実施日「${openDeleteScoreDialog?.data?.testDate}」を削除しますか？`}
                            </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button color="inherit" variant="contained" sx={{fontWeight:'bold'}} onClick={()=>setOpenDeleteScoreDialog({isOpen:false,data:null})}>キャンセル</Button>
                        <Button variant="contained" onClick={handleOKDeleteScore}>削除</Button>
                    </DialogActions>
                </Dialog>
            }

            <FetchHelper 
                fetchId={GET_RESULT_LIST} 
                onComplete={(success,data,error)=>success?
                    handleGetListSuccess(success,data,error):
                    handleGetListError(success,data,error)}
            ></FetchHelper>
            <FetchHelper 
                fetchId={GET_USER_ANSWER} 
                onComplete={(success,data,error)=>success?
                    handleGetUserAnswerSuccess(data):
                    handleGetUserAnswerError(data)}
            ></FetchHelper>
            <FetchHelper 
                fetchId={GET_SCORE} 
                onComplete={(success,data,error)=>success?
                    handleGetScoreSuccess(data):
                    handleGetScoreError(data)}
            ></FetchHelper>
            <FetchHelper 
                fetchId={DELETE_SCORE} 
                onComplete={(success,data,error)=>success?
                    handleDeleteScoreSuccess(data):
                    handleDeleteScoreError(data)}
            ></FetchHelper>
            <FetchHelper
                fetchId={GET_TRACK_LINE}
                onComplete={(success, data, error) =>{
                        success ? handleGetTrackLineSuccess(data) : handleGetTrackLineError(data)
                    }
                }
            />
        </>  
    );
};

const mapStateToProps = (state: any) => {
    return {
        
    };
};
const mapDispatchToProps = (dispatch: any) => {
    return {
        onGetList: (params: any ) => dispatch(actionCreators.fetch(GET_RESULT_LIST,"/score/get-result-list","POST",params,false,true)),
        onDeleteScore: (params: any ) => dispatch(actionCreators.fetch(DELETE_SCORE,"/score/delete-score","POST",params,false,true)),
        onGetUserAnswer: (params: any ) => dispatch(actionCreators.fetch(GET_USER_ANSWER,"/question/get-user-answer","POST",params,false,true)),
        onGetScore: (params: any ) => dispatch(actionCreators.fetch(GET_SCORE,"/score/get-score","POST",params,false,true)),
        onGetTrackLine:(params:any) =>dispatch(actionCreators.fetch(GET_TRACK_LINE,'/user/get-track-line','POST',params,false,true)),
        onDeleteUserSuccess:()=>dispatch(actionCreators.showMessage({
            type: "info",
            title: "実施結果削除",
            body: "実施結果を削除しました。",
        })),
        onDeleteUserError:()=>dispatch(actionCreators.showMessage({
            type: "error",
            title: "実施結果削除",
            body: "実施結果削除のエラー",
        }))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TestList);